import React, { useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import { PageLink, PageTitle } from '../../../../_metronic/layout/core'
import Functions from '../../../../setup/utilities/Functions'
import CashFlowToolbar from './components/CashFlowToolbar'
import CashFlowListing from './components/CashFlowListing'


const CashFlowWrapper : React.FC = () => {
  const intl = useIntl()
  const teamBreadCrumbs: Array<PageLink> = [
    {
      title: 'Home',
      path: '',
      isSeparator: false,
      isActive: false,
    },
    {
      title: '',
      path: '',
      isSeparator: true,
      isActive: false,
    },
    {
      title: intl.formatMessage({ id: 'accounting.cash.flow.menu' }),
      path: '',
      isSeparator: false,
      isActive: false,
    },
    {
      title: '',
      path: '',
      isSeparator: true,
      isActive: false,
    },
  ]
  const [cashFlow, setCashFLow] = useState<ICashFlow|undefined|null>(null)
  const [action, setAction] = useState<string>('')
  const [show, setShow] = React.useState(false)
  const handleClose = async (isSubmit: boolean) => {
    if (!isSubmit) {
      const isConfirmed = await Functions.sweetAlert(
        '<span class="mt-5">' + intl.formatMessage({ id: 'action.message' }) + '</span>',
        'warning',
        true,
        intl.formatMessage({ id: 'action.cancel' }),
        intl.formatMessage({ id: 'action.return' }),
        'btn btn-primary mt-10 mb-10',
        'btn btn-active-light mt-10 mb-10',
      )
      if (isConfirmed) {
        setShow(false)
      }
    } else {
      setShow(false)
    }
  }
  const handleShow = (cashFlow: ICashFlow|undefined|null, action: string) => {
    setCashFLow(cashFlow)
    setAction(action)
    setShow(true)
  }

  useEffect(() => {}, [cashFlow])
  return (
    <>
      <PageTitle breadcrumbs={teamBreadCrumbs} pageTitle={intl.formatMessage({ id: 'accounting.cash.flow.list' })}>
        <CashFlowToolbar handleShow={handleShow}/>
      </PageTitle>
      <CashFlowListing show={show} handleClose={handleClose} cashFlowSelected={cashFlow} action={action}/>
    </>
  )
}

export default CashFlowWrapper
